import moment from 'moment';

export function getFormattedDate(date: any) {
    if (date) {
        const myDate = moment(
            date?.format('MM/DD/YYYY')
        ).toISOString();
        return myDate;
    }
    return null;
}

export const createLinkModel = (sideSheetData: any) => {

    const departments = sideSheetData.targetDepartments?.length > 0 ?
        sideSheetData.targetDepartments.map((dept: any) => dept.id) : null;

    const model = {
        appId: sideSheetData.appId,
        name: sideSheetData.name,
        description: sideSheetData.description,
        url: sideSheetData.url,
        iconText: sideSheetData.iconText,
        target: {
            department: departments,
        },
        startDate:
            getFormattedDate(sideSheetData.startDate),
        endDate:
            getFormattedDate(sideSheetData.endDate),
        loginId: sideSheetData.loginId,
        enterpriseId: sideSheetData.enterpriseId,
    };

    return model;
}